/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAoChat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7.6 7c.84 0 1.26 0 1.58.163.283.144.513.374.657.656C10 8.14 10 8.561 10 9.4v5.2c0 .84 0 1.26-.163 1.58a1.503 1.503 0 0 1-.656.657C8.86 17 8.439 17 7.6 17h-.2c-.84 0-1.26 0-1.58-.163a1.503 1.503 0 0 1-.657-.656C5 15.86 5 15.439 5 14.6V9.4c0-.84 0-1.26.163-1.58.144-.283.374-.513.656-.657C6.14 7 6.561 7 7.4 7z" />
        <path
          clipRule="evenodd"
          d="M16.1 4.008c1.56.024 2.509.123 3.279.515a4.8 4.8 0 0 1 2.098 2.098C22 7.648 22 8.991 22 11.68v.64l-.008 1.78c-.024 1.56-.123 2.509-.515 3.279a4.8 4.8 0 0 1-2.098 2.098c-.77.392-1.718.49-3.278.515L14.32 20H9.68c-2.52 0-3.86 0-4.863-.43l-.196-.093a4.8 4.8 0 0 1-1.913-1.767l-.185-.331c-.392-.77-.49-1.718-.515-3.278L2 12.32v-.641c0-2.52 0-3.86.43-4.863l.093-.196A4.8 4.8 0 0 1 4.29 4.708l.331-.185C5.648 4 6.991 4 9.68 4h4.64zM9.68 6c-1.377 0-2.29.001-2.99.059-.676.055-.976.153-1.16.247a2.8 2.8 0 0 0-1.224 1.223c-.094.185-.192.485-.247 1.161C4 9.39 4 10.303 4 11.68v.64c0 1.377.001 2.29.059 2.99.055.676.153.976.247 1.16a2.8 2.8 0 0 0 1.223 1.224c.185.094.485.192 1.161.247.7.058 1.613.059 2.99.059h4.64c1.377 0 2.29-.001 2.99-.059.676-.055.976-.153 1.16-.247a2.799 2.799 0 0 0 1.224-1.223c.094-.185.192-.485.247-1.161.058-.7.059-1.613.059-2.99v-.64c0-1.377-.001-2.29-.059-2.99-.055-.676-.153-.976-.247-1.16a2.8 2.8 0 0 0-1.223-1.224c-.185-.094-.485-.192-1.161-.247C16.61 6 15.697 6 14.32 6z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgAoChat as AoChat };
